import ChatForm from './chat_form';
import { create_public_guest } from './chat_utils';
import ChatSpace from './chat_space';

export default class ChatWelcome {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.profile = opts.profile;
    this.setup();
  }

  setup() {
    this.$chat_welcome_screen = $(document.createElement('div')).addClass(
      'chat-welcome'
    );

    const welcome_html = `
			<div class='chat-welcome-header'>
					<span class='hero-icon'>
						<svg xmlns="http://www.w3.org/2000/svg" width="1.4rem" height="1.4rem" viewBox="0 0 24 24">
						<path d="M12 1c-6.627 0-12 4.364-12 9.749 0 3.131 1.817 5.917 4.64 7.7.868 2.167-1.083 4.008-3.142 4.503 2.271.195 6.311-.121 9.374-2.498 7.095.538 13.128-3.997 13.128-9.705 0-5.385-5.373-9.749-12-9.749z"/>
						</svg>
					</span>
					<h3>${__('Hi there ! 🙌🏼')}</h3>
					<p>
						${__('We make it simple to connect with us.')}
						${__('Ask us anything, or share your feedback.')}
					</p>
			</div>
		`;

    const status_text =
      this.profile.chat_status === 'Online'
        ? __('We are online')
        : __('We are offline');

    const reason_text =
      this.profile.chat_status === 'Online'
        ? __('Typically replies in a few hours')
        : __('Just drop a message and we will get back to you soon');

    const bottom_html = `
			<div class='chat-welcome-footer'>
				<p class='status-content'>${status_text}</p>
				<p class='hero-content'>${reason_text}</p>
				<button type='button' class='btn btn-primary w-100 mb-2'
					id='start-conversation'>
					${__('Start Private Chat')}
				</button>
				<button type='button' class='btn btn-outline-primary w-100'
					id='join-public-chat'>
					${__('Join Public Chatroom')}
				</button>
				<a class='chat-footer welcome-footer' target='_blank' href='https://kdj.lk'>
					${__('⚡ Powered by KDJ')}
				</a>
			</div>
		`;

    this.$chat_welcome_screen.append(welcome_html + bottom_html);
  }

  setup_events() {
    const me = this;
    $('#start-conversation').on('click', function () {
      me.chat_form = new ChatForm({
        $wrapper: me.$wrapper,
        profile: me.profile,
      });
      me.chat_form.render();
    });

    $('#join-public-chat').on('click', async function () {
      // Create a better form modal instead of prompt
      const modal_html = `
        <div class="modal fade" id="public-chat-modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">${__('Join Public Chatroom')}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                <form id="public-chat-form">
                  <div class="mb-3">
                    <label class="form-label">${__('Your Name')}</label>
                    <input type="text" class="form-control" id="guest-name" required>
                  </div>
                  <div class="mb-3">
                    <label class="form-label">${__('Your Email')}</label>
                    <input type="email" class="form-control" id="guest-email" required>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">${__('Cancel')}</button>
                <button type="button" class="btn btn-primary" id="join-chat-btn">${__('Join Chatroom')}</button>
              </div>
            </div>
          </div>
        </div>
      `;
      
      // Remove existing modal if any
      $('#public-chat-modal').remove();
      
      // Add modal to body
      $('body').append(modal_html);
      
      // Show modal
      $('#public-chat-modal').modal('show');
      
      // Handle join button click
      $('#join-chat-btn').on('click', async function() {
        const name = $('#guest-name').val().trim();
        const email = $('#guest-email').val().trim();
        
        if (!name || !email) {
          alert(__('Please fill in all fields'));
          return;
        }
        
        try {
          // Show loading
          $('#join-chat-btn').prop('disabled', true).text(__('Joining...'));
          
          const res = await create_public_guest({
            full_name: name,
            email: email,
            message: `${name} joined the public chatroom`
          });

          if (res) {
            $('#public-chat-modal').modal('hide');
            me.chat_space = new ChatSpace({
              $wrapper: me.$wrapper,
              room_config: res,
              profile: me.profile,
            });
            me.chat_space.render();
          } else {
            throw new Error('Invalid response from server');
          }
        } catch (error) {
          console.error('Error joining public chat:', error);
          alert(__('Error joining public chatroom: ') + (error.message || 'Unknown error'));
          $('#join-chat-btn').prop('disabled', false).text(__('Join Chatroom'));
        }
      });
    });
  }

  render() {
    this.$wrapper.html(this.$chat_welcome_screen);
    this.setup_events();
  }
}
